import Backbone from 'backbone/backbone-min.js';

window.Backbone = Backbone;
